<script>
/**
 * Login component
 */
export default {
  data() {
    return {
      email: "",
      password: "",
      tryingToLogIn: false,
      isAuthError: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      errorMessage: "",
      errors: null,
    };
  },
  methods: {
    login() {
      axios
        .post("api/signin", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          if (response.data.status) {
            localStorage.setItem("LoggedUser", "LOGGED");
            var data = response.data.data;
            localStorage.setItem("reloaded","false");
            localStorage.setItem("expires_in", data.expires_in);
            localStorage.setItem("logged_time", new Date());
            localStorage.setItem("access_tocken", data.access_token);
            localStorage.setItem(
              "full_name",
              data.user.first_name + " " + data.user.last_name
            );
            localStorage.setItem("id", data.user.id);
            localStorage.setItem("uuid", data.user.uuid);
            localStorage.setItem("email", data.user.email);
              localStorage.setItem("account_type", data.user.account_type);
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("menus", JSON.stringify(data.menus));
            let a=localStorage.getItem("last_route");
            if(a=='undefined' || a==null){
                this.$router.push('/dashboard')
            }else{
                this.$router.push(a);
            }
              this.$swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: 'Successfully Logged In',
                  showConfirmButton: false,
                  timer: 1000
              });
          } else {
            this.errorMessage = response.data.message;
            this.showAlert();
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    passwordEyeToggle() {
      var x = document.getElementById("input-2");
      var y = document.getElementById("eye-1");
      var z = document.getElementById("eye-2");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="#" class="text-dark">
        <i class="fas fa-home h2"></i>
      </a>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Welcome Back !</h5>
                      <p>Sign in to manage Naxas Travel.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img src="/images/profile-img.png" alt class="img-fluid" />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <a href="/">
                    <div class="avatar-md profile-user-wid mb-4">
                      <span class="avatar-title rounded-circle bg-light">
                        <strong class="text-primary">Naxas Travel</strong>
                      </span>
                    </div>
                  </a>
                </div>
                <div v-if="errors" class="font-bold mb-4 ">
                  <div v-for="(v, k) in errors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                      {{ error }}
                    </p>
                  </div>
                </div>
                <b-alert :show="dismissCountDown" dismissible variant="danger">
                  <p>{{errorMessage}}</p>
                </b-alert>

                <b-form class="p-2" @submit.prevent="login">
                  <slot />
                  <b-form-group id="input-group-1" label="Email" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      name="email"
                      v-model="email"
                      type="text"
                      placeholder="Enter email"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group id="input-group-2" label="Password" label-for="input-2">
                    <b-form-input
                      id="input-2"
                      v-model="password"
                      name="password"
                      type="password"
                      placeholder="Enter password"
                    ></b-form-input>
                      <span class="eye-mask" >
                      <i class="fa fa-eye" aria-hidden="true" @click="passwordEyeToggle()" id="eye-1"> </i>
                      <i class="fa fa-eye-slash" aria-hidden="true" @click="passwordEyeToggle()" id="eye-2"> </i>
                  </span>
                  </b-form-group>

                  <div class="custom-control custom-checkbox">
                    <input id="customControlInline" type="checkbox" class="custom-control-input" />
                    <label class="custom-control-label" for="customControlInline">Remember me</label>
                  </div>
                  <div class="mt-3">
                    <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                  </div>
                  <div class="mt-4 text-center">
                    <a href="/#/forgot_password" class="text-muted">
                      <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                    </a>
                  </div>
                </b-form>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->

<!--            <div class="mt-5 text-center">-->
<!--              <p>-->
<!--                Don't have an account ?-->
<!--                <a-->
<!--                  href="/register"-->
<!--                  class="font-weight-medium text-primary"-->
<!--                >Signup now</a>-->
<!--              </p>-->
<!--            </div>-->
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->
</template>

<style >
  .eye-mask{
    display: flex;
    position: absolute;
    right: 40px;
    cursor: pointer;
  }
  /*#eye-1{*/
  /*  display: none;*/
  /*}*/
   #input-group-2 .bv-no-focus-ring{
      display: flex;
      justify-content:center;
      text-align: right;
      flex-wrap:wrap;
      flex-direction: column;
  }
</style>
